import { MFormation } from '@argalis-apps/models';

export const TESTDATA: MFormation.IFormInfo = {
  id: 2,
  // tslint:disable-next-line:max-line-length
  libelle: `Nom de ma formation Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco`,
  downloadUri: 'http://.........',
  backgroundPictureUri:
    'https://images.pexels.com/photos/531880/pexels-photo-531880.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
  isParcours: false,
  domaine: {
    id: 21,
    libelle: 'Mon groupe',
    type: 'groupe',
    parent: {
      id: 20,
      libelle: 'Ma famille',
      type: 'famille',
      parent: {
        id: 19,
        libelle: 'Mon secteur',
        type: 'secteur'
      }
    }
  },
  focus: {
    accroche: `Texte d'accroche commerciale: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco`,
    objectifs: `- texte a puce d'options pour voir<br>- second point`,
    public: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco`
  },
  details: [
    {
      title:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
      content:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco'
    },
    {
      title: 'Lorem ipsum dolor sit amet',
      content: 'Lorem ipsum dolor sit amet, lorem ipsum ...'
    },
    {
      title: 'Lorem ipsum dolor sit amet',
      content: 'Lorem ipsum dolor sit amet, lorem ipsum ...'
    },
    {
      title: 'Lorem ipsum dolor sit amet',
      content: 'Lorem ipsum dolor sit amet, lorem ipsum ...'
    },
    {
      title: 'Lorem ipsum dolor sit amet',
      content: 'Lorem ipsum dolor sit amet, lorem ipsum ...'
    },
    {
      title: 'Lorem ipsum dolor sit amet',
      content: 'Lorem ipsum dolor sit amet, lorem ipsum ...'
    }
  ],
  inscriptions: {
    groupe: '2 à 12 personnes',
    duree: '126 h (18 jours)'
  },
  sessions: [
    {
      id: 1,
      ref: 'session 1',
      postal: '',
      places: 2,
      debut: new Date('01/01/18'),
      fin: new Date('02/02/18'),
      site: [
        {
          id: 8,
          libelle: 'site de formation 8',
          postal: ''
        }
      ],
      responsable: {
        id: 3,
        nom: 'Machin',
        prenom: 'M.',
        mail: 'm.machin@truc.com',
        tel: '09 18 27 36 45'
      }
    },
    {
      id: 2,
      ref: 'session 2',
      postal: '',
      places: 0,
      debut: new Date('02/02/18'),
      fin: new Date('03/03/18'),
      site: [
        {
          id: 1,
          libelle: 'site de formation 1',
          postal: ''
        }
      ],
      responsable: {
        id: 3,
        nom: 'Machin',
        prenom: 'M.',
        mail: 'm.machin@truc.com',
        tel: '09 18 27 36 45'
      }
    },
    {
      id: 3,
      ref: 'session 3',
      postal: '',
      places: 5,
      debut: new Date('03/03/18'),
      fin: new Date('04/04/18'),
      site: [
        {
          id: 1,
          libelle: 'site de formation 1',
          postal: ''
        }
      ],
      responsable: {
        id: 3,
        nom: 'Machin',
        prenom: 'M.',
        mail: 'm.machin@truc.com',
        tel: '09 18 27 36 45'
      }
    },
    {
      id: 4,
      ref: 'session 4',
      postal: '',
      places: 0,
      debut: new Date('04/04/18'),
      fin: new Date('05/05/18'),
      site: [
        {
          id: 1,
          libelle: 'site de formation 1',
          postal: ''
        }
      ],
      responsable: {
        id: 3,
        nom: 'Machin',
        prenom: 'M.',
        mail: 'm.machin@truc.com',
        tel: '09 18 27 36 45'
      }
    },
    {
      id: 5,
      ref: 'session 5',
      postal: '',
      places: 1,
      debut: new Date('05/05/18'),
      fin: new Date('06/06/18'),
      site: [
        {
          id: 1,
          libelle: 'site de formation 1',
          postal: ''
        }
      ],
      responsable: {
        id: 3,
        nom: 'Machin',
        prenom: 'M.',
        mail: 'm.machin@truc.com',
        tel: '09 18 27 36 45'
      }
    },
    {
      id: 6,
      ref: 'session 6',
      postal: '',
      places: 0,
      debut: new Date('06/06/18'),
      fin: new Date('07/07/18'),
      site: [
        {
          id: 1,
          libelle: 'site de formation 1',
          postal: ''
        }
      ],
      responsable: {
        id: 3,
        nom: 'Machin',
        prenom: 'M.',
        mail: 'm.machin@truc.com',
        tel: '09 18 27 36 45'
      }
    },
    {
      id: 7,
      ref: 'session 7',
      postal: '',
      places: 15,
      debut: new Date('07/07/18'),
      fin: new Date('08/08/18'),
      site: [
        {
          id: 1,
          libelle: 'site de formation 1',
          postal: ''
        }
      ],
      responsable: {
        id: 3,
        nom: 'Machin',
        prenom: 'M.',
        mail: 'm.machin@truc.com',
        tel: '09 18 27 36 45'
      }
    },
    {
      id: 8,
      ref: 'session 8',
      postal: '',
      places: 7,
      debut: new Date('08/08/18'),
      fin: new Date('09/09/18'),
      site: [
        {
          id: 2,
          libelle: 'site de formation 2',
          postal: ''
        }
      ],
      responsable: {
        id: 3,
        nom: 'Machin',
        prenom: 'M.',
        mail: 'm.machin@truc.com',
        tel: '09 18 27 36 45'
      }
    },
    {
      id: 9,
      ref: 'session 9',
      postal: '',
      places: 3,
      debut: new Date('09/09/18'),
      fin: new Date('10/10/18'),
      site: [
        {
          id: 2,
          libelle: 'site de formation 2',
          postal: ''
        }
      ],
      responsable: {
        id: 3,
        nom: 'Machin',
        prenom: 'M.',
        mail: 'm.machin@truc.com',
        tel: '09 18 27 36 45'
      }
    },
    {
      id: 10,
      ref: 'session 10',
      postal: '',
      places: 0,
      debut: new Date('10/10/18'),
      fin: new Date('11/11/18'),
      site: [
        {
          id: 2,
          libelle: 'site de formation 2',
          postal: ''
        }
      ],
      responsable: {
        id: 3,
        nom: 'Machin',
        prenom: 'M.',
        mail: 'm.machin@truc.com',
        tel: '09 18 27 36 45'
      }
    },
    {
      id: 11,
      ref: 'session 11',
      postal: '',
      places: 11,
      debut: new Date('11/11/18'),
      fin: new Date('12/12/18'),
      site: [
        {
          id: 2,
          libelle: 'site de formation 2',
          postal: ''
        }
      ],
      responsable: {
        id: 3,
        nom: 'Machin',
        prenom: 'M.',
        mail: 'm.machin@truc.com',
        tel: '09 18 27 36 45'
      }
    }
  ]
};
